// extracted by mini-css-extract-plugin
module.exports = {"navbar":"navbar-module--navbar--8fnkJ"};